import { throttle, getScrollPosition } from '../utils/dom';
import { elements, isDesktop, SCROLL_THRESHOLD } from './config';

function onScroll(): void {
    const pos: number = getScrollPosition();

    if (pos > SCROLL_THRESHOLD) {
        if (elements.navbar) {
            elements.navbar.classList.add('mp-navbar-shadow', 'sticky');
        }
        
        if (!isDesktop() && elements.content && elements.navbar) {
            elements.content.style.paddingTop = elements.navbar.offsetHeight + 'px';
        }
    } else {
        const hasVisibleDropdown: boolean = !!document.querySelector('.mp-navbar-dropdown.visible');
        
        if (!hasVisibleDropdown) {
            if (elements.navbar) {
                elements.navbar.classList.remove('mp-navbar-shadow', 'sticky');
            }
            
            if (elements.content) {
                elements.content.style.paddingTop = '0';
            }
        }
    }
}

const handleScroll: () => void = throttle(onScroll, 16);

export function initScroll(): void {
    window.addEventListener('scroll', handleScroll, { passive: true });
    setTimeout(handleScroll, 0);
}